// extracted by mini-css-extract-plugin
module.exports = {"TabContainer":"SubNav_TabContainer__12gsY","Tabs":"SubNav_Tabs__1IPFK","Tab":"SubNav_Tab__2Btt4","Mui-selected":"SubNav_Mui-selected__1cujc"};